import { Alert, Button, Icon, IconButton, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import {
    SurveyDto,
    SurveyQuestionAnswerInput,
    SurveyService,
} from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import { UserContext } from "../../../contexts/UserContext";
import SurveyQuestion from "../components/SurveyQuestion";

export default function CustomerExperienceSurveyDialog(params: { id: number }) {
    const [surveyData, setSurveyData] = useState<SurveyDto | null>(null);
    const [surveyAnswer, setSurveyAnswer] = useState<
        SurveyQuestionAnswerInput[]
    >([]);
    const [error, setError] = useState(false);

    const user = useContext(UserContext);
    const { closeDialog } = useContext(DialogContext);

    useEffect(() => {
        getData();
    }, []);

    const selectQuestionOption = (questionId: number, option: number) => {
        const newAnswer = surveyAnswer.map((a) =>
            a.questionId === questionId
                ? { ...a, selectedOptions: [option] }
                : a
        );
        setSurveyAnswer(newAnswer);
    };

    const setQuestionNote = (questionId: number, notes: string) => {
        const newAnswers = surveyAnswer.map((answer) =>
            answer.questionId === questionId
                ? {
                      ...answer,
                      notes: notes,
                  }
                : answer
        );

        setSurveyAnswer(newAnswers);
    };

    const answerSurvey = async () => {
        if (!areAnswersValid(surveyAnswer)) {
            setError(true);
            return;
        }

        await SurveyService.answerSurvey(params.id, "1", {
            customerId: user.id,
            answers: surveyAnswer,
        });

        closeDialog();
    };

    const areAnswersValid = (answers: SurveyQuestionAnswerInput[]) => {
        const hasCustomerAnsweredAllQuestions = answers.every(
            (answer) => answer.selectedOptions.length > 0
        );

        if (!hasCustomerAnsweredAllQuestions) {
            return false;
        }

        return true;
    };

    const getData = async () => {
        const result = await SurveyService.getPendingSurvey("1");
        setSurveyData(result);

        setBlankStateForRecivedSurvey(result);
    };

    const setBlankStateForRecivedSurvey = (data: SurveyDto) => {
        const answers: SurveyQuestionAnswerInput[] = data.questions.map(
            (question) => ({
                questionId: question.id,
                selectedOptions: [],
                notes: null,
            })
        );

        setSurveyAnswer(answers);
    };

    const closeDialogAndIgnoreSurvey = () => {
        SurveyService.ignoreSurvey(surveyData.id, "1");
        closeDialog();
    };

    return (
        <DialogContainer preferredWith={400}>
            {surveyData !== null && (
                <>
                    <DialogHeader
                        title={surveyData.title}
                        action={
                            <IconButton onClick={closeDialogAndIgnoreSurvey}>
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />

                    <Stack spacing={2} sx={{ p: 2 }}>
                        {surveyData.questions !== null &&
                            surveyData.questions.map((question) => (
                                <SurveyQuestion
                                    question={question}
                                    setQuestionNote={setQuestionNote}
                                    state={surveyAnswer}
                                    selectQuestionOption={selectQuestionOption}
                                    key={question.id}
                                />
                            ))}

                        {error && (
                            <Alert severity="error">
                                لطفا به تمام سوالات نظرسنجی پاسخ دهید.
                            </Alert>
                        )}

                        <Button variant="contained" onClick={answerSurvey}>
                            ارسال پاسخ
                        </Button>
                    </Stack>
                </>
            )}
        </DialogContainer>
    );
}
